import React from "react";
import { colHeadersAll } from "./helper";
import { approvedProductsService } from "services/approvedProducts.service";
import ApprovedProducts from "./Components/ApprovedProducts";

const ApprovedProductsAll = () => {

  const IS_ADMIN = true
  const TITLE_PAGE = "Visa Approved Solutions Directory for EMV 3DS (Internal Version)"
  const SEARCHBAR_HELP_TEXT = "Search matches on the following fields: Company, BID, Component, Product, Visa Secure Approval ID or EMVCo Reference Number."

  return <ApprovedProducts
    api={approvedProductsService.GetAll}
    apiExport={approvedProductsService.ExportAll}
    colHeaders={colHeadersAll}
    helpText={SEARCHBAR_HELP_TEXT}
    isAdmin={IS_ADMIN}
    titlePage={TITLE_PAGE}
  />

};

export default ApprovedProductsAll;
